import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IMasterList } from "../../../Pages/Master/IMaster";

interface IUpdate extends IReduxState<IMasterList> {
  updateableDate?: IMasterList;
}

export const UpdateMasterSlicer = createSlice({
  name: "UpdateMaster",
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateMaster: (state, _) => {
      state.isLoading = true;
    },
    successUpdateMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    mastersUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateMasterState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateMaster,
  failureUpdateMaster,
  successUpdateMaster,
  mastersUpdateableData,
  clearUpdateMasterState,
  clearUpdateableData,
} = UpdateMasterSlicer.actions;

export default UpdateMasterSlicer.reducer;
